import ResponseFilter from "../../ResponseFilter";
import { decryptResponseData } from "../../components/salaryGeneration/encryptionAndDecryption";
import { getEmployeeOnHold } from "../../config/services/employeeServices";
import {
    GET_EMPLOYEE_ON_HOLD_REQUEST,
    GET_EMPLOYEE_ON_HOLD_SUCCESS,
    GET_EMPLOYEE_ON_HOLD_FAILURE,
} from "./actionType";

export default function getEmployeeOnHoldAction(props) {
    let { useDispatch, params } = props
    return (dispatch) => {
        dispatch(getEmployeeOnHoldActionRequest());
        getEmployeeOnHold(params).then((res) => {
            let { status } = ResponseFilter(res)
            if (status) {
                useDispatch({
                    type: 'typeCheckSet', payload: {
                        miniLoader: false,
                        onHoldEmployeeList: decryptResponseData(res?.data?.responseData?.result),
                        onHoldEmployeeDataCount: res?.data?.responseData?.dataCount,
                    }
                })
            } else {

                useDispatch({
                    type: 'typeCheckSet', payload: {
                        miniLoader: false,
                        resFailMsg: true,
                        responseMessage: res?.data?.error?.responseMessage
                    }
                })

                setTimeout(() => {
                    useDispatch({
                        type: 'typeCheckSet', payload: {
                            resFailMsg: false,
                        }
                    })
                }, 4000)
            }
        })
            .catch((error) => {
                dispatch(getEmployeeOnHoldActionFailure(error));
            });
    };
};

const getEmployeeOnHoldActionRequest = () => {
    return {
        type: GET_EMPLOYEE_ON_HOLD_REQUEST,
    };
};

const getEmployeeOnHoldActionSuccess = (data) => {
    return {
        type: GET_EMPLOYEE_ON_HOLD_SUCCESS,
        payload: data,
    };
};

const getEmployeeOnHoldActionFailure = (error) => {
    return {
        type: GET_EMPLOYEE_ON_HOLD_FAILURE,
        payload: error,
    };
};
export {
    getEmployeeOnHoldAction,
    getEmployeeOnHoldActionRequest,
    getEmployeeOnHoldActionSuccess,
    getEmployeeOnHoldActionFailure,
};